module.exports = __webpack_public_path__ + "654c651a0ca6c9d31a30b44fe3b7f969.svg";